// @flow
import { socketEmit } from "../../../../socket";
import { Constant } from "../../webjam/constant";
import { FEATURE_CUSTOM_REDUX } from "../constant";
import { hideApiLoader, setLoginModal, setLogoutType, setUserIsLogin, setUserLoginData, showApiLoader } from "../redux/tool-webjam/actions";
import { dispatch, getBaseConfig, getStore, isSocialMobileApp } from "../Utils";
import { getMySubscription, getPendingInvitations } from "./paymentRequest";
import { checkUserSession, onUserLogout } from "./Request.d";

export const validateAuth = (showLoder = true, cb: Function = null) => {
    let getLocalAuth = localStorage.getItem("auth");

    const {
        isUserLogin
    } = getStore(FEATURE_CUSTOM_REDUX);

    if (getLocalAuth && !isUserLogin) {
        getLocalAuth = JSON.parse(getLocalAuth);
        if (getLocalAuth.hasOwnProperty("token")) {
            if (showLoder) {
                dispatch(showApiLoader())
            }
            Promise.all([
                checkUserSession(getLocalAuth.token, "helper"),
                dispatch(getMySubscription(null, 5)),
                dispatch(getPendingInvitations({
                    status: "pending",
                    count: true
                }))
            ]).then((res, subscription) => {

                dispatch(hideApiLoader())
                let auth = res[0]?.data;

                console.log("authauthauth ", auth)
                if (cb) {
                    cb({
                        status: auth.status == 1 ? true : false
                    })
                }

                if (auth.status == 1) {
                    dispatch(setLoginModal(false));
                    dispatch(setUserIsLogin(true));
                } else {
                    localStorage.removeItem("auth");
                    dispatch(setLoginModal(true));
                    dispatch(setUserIsLogin(false));
                }

            })
            // checkUserSession(getLocalAuth.token)
            // .then((res) => {
            //     if (cb) {
            //         cb({
            //             status: res.status == 1 ? true : false
            //         })
            //     }
            //     if (showLoder) {
            //         dispatch(hideApiLoader())
            //     }

            //     if (res.status == 1) {
            //         dispatch(getMySubscription())
            //         dispatch(setLoginModal(false));
            //         dispatch(setUserIsLogin(true));
            //     } else {
            //         localStorage.removeItem("auth");
            //         dispatch(setLoginModal(true));
            //         dispatch(setUserIsLogin(false));
            //     }
            // });
        } else {
            cb({
                status: false
            })
        }
    } else {
        cb({
            status: false
        })
    }
}

export const handleUserLogout = async (props) => {
    const { dispatch, userLoginData, moderatorCount, authOrganization } = props;
    const isSocialApp = isSocialMobileApp() ? true : false;
    const userSocialId = userLoginData?.user?.rtaSocialUserId;

    if (userLoginData.isAdmin && moderatorCount == 0) {
        socketEmit('end_meeting_for_all', {
            organization_id: authOrganization._id
        });
    }

    localStorage.removeItem("auth");
    localStorage.removeItem("socialAuthToken");
    dispatch(setUserIsLogin(false));

    dispatch(setUserLoginData({
        isAdmin: false,
        isOpenRoom: false,
        isAlreadyPaid: false,
        isLogged: false,
        isOpenRoom: false,
        isPrivate: false,
        isRoomClaimed: false,
        data: '',
        room: '',
        user: ''
    }, 4));

    let socialBaseUrl = getBaseConfig("socialBaseUrl")
    if (!isSocialApp && userSocialId) {
        // logout for normal web user
        window.parent.location.href = `${socialBaseUrl}/users/api_logout/${userSocialId}/false`;
        return false;
    } else if (userSocialId) {
        // logout for mobile user
        await onUserLogout(userSocialId);
        return false;
    } else {
        // logout for invite user
        window.parent.location.href = socialBaseUrl;
        return false;
    }

    // dispatch(setLogoutType(false));
}